import * as React from 'react';
import { Chart } from 'react-chartjs-2';
import { Chart as ChartJS, ChartData, ChartOptions, ArcElement, Legend, Tooltip } from 'chart.js';
import { ChartRefContext } from "../context/ChartRefs";

ChartJS.register(ArcElement);
ChartJS.register(Legend);
ChartJS.register(Tooltip);

export type PieChartProps = {
    data: ChartData;
    options: ChartOptions;
    label: string;
}

export const PieChart = (props: PieChartProps): JSX.Element => {
    const [, dispatch] = React.useContext(ChartRefContext);
    const chartRef = React.createRef<any>();

    React.useEffect(() => {

        ChartJS.defaults.font.family = "AvenirBook";
        ChartJS.defaults.font.size = 14;

        dispatch({
            type: 'ADDCHARTREF', payload: {
                chartref: {
                    ref: chartRef.current,
                    label: props.label
                }
            }
        });

    }, [])

    React.useEffect(() => {
        chartRef.current?.update();
    }, [props.data])

    return <div className={'c-pstats__chart'}>
        <h3>{props.label}</h3>
        <Chart
            type={'doughnut'}
            ref={chartRef}
            data={props.data}
            options={props.options}
        />

    </div>;
}

